var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-player" },
    [
      _c("youtube", {
        ref: "youtube",
        attrs: {
          "video-id": _vm.source,
          "player-vars": _vm.options,
          fitParent: "",
          resize: ""
        },
        on: { playing: _vm.onPlay }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }